import React, { useState } from "react";
import Line from "../../../components/Line";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { toast } from "react-toastify";

const GreetTeam = () => {
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm();
  const [greetMsg, setGreetMsg] = useState(null);
  const [loader, setLoader] = useState(false);
  const [greetLoader, setGreetLoader] = useState(false);

  const axiosPrivate = useAxiosPrivate();

  const onSubmit = async (data) => {
    if (!data.greetings) {
      toast.error("Oops! It looks like you forgot to write your message.");
      return;
    }

    setLoader(true);
    try {
      let isMounted = true;
      const controller = new AbortController();
      await axiosPrivate
        .post(
          "employee/sendGreetings",
          {
            greetings: data.greetings,
            isSkipped: false,
          },
          {
            signal: controller.signal,
          }
        )
        .then((response) => {
          if (response.data.status) {
            toast.success("Greetings Sent successfully!", { type: "success" });
            navigate("/onboarding/onboard-final");
          } else {
            setLoader(false);
          }
        })
        .catch((err) => {
          console.error(err);
        });

      return () => {
        isMounted = false;
        controller.abort();
      };
    } catch (err) {
    }
  };

  const handleChange = (e) => {
    setGreetMsg(e.target.value);
  };

  const skipGreetingButton = async () => {
    setGreetLoader(true);
    try {
      let isMounted = true;
      const controller = new AbortController();
      await axiosPrivate
        .post(
          "employee/sendGreetings",
          {
            greetings: "",
            isSkipped: true,
          },
          {
            signal: controller.signal,
          }
        )
        .then((response) => {
          if (response.data.status) {
            toast.success("Greetings skipped successfully!", {
              type: "success",
            });
            navigate("/onboarding/onboard-final");
          } else {
            setGreetLoader(false);
          }
        })
        .catch((err) => {
          console.error(err);
        });

      return () => {
        isMounted = false;
        controller.abort();
      };
    } catch (err) {
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex-1 justify-center max-w-[660px]">
          <div className="pb-12">
            <h2 className="text-2xl leading-8 font-bold text-gray-800">
              Let’s greet everyone
            </h2>
            <p className="text-sm leading-5 font-normal text-gray-500 pt-2 pb-6">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries.
            </p>
            <span className="text-gray-500 text-sm leading-5 font-medium">
              Messages
            </span>
            <textarea
              name="greeting"
              className="form-textarea mt-1 block w-full"
              rows="6"
              {...register("greetings")}
              onChange={(e) => handleChange(e)}
            ></textarea>
          </div>
          <Line />
          <div className="flex justify-between pt-6">
            <div>
              <input
                type="button"
                className="btn btn--border"
                onClick={() => navigate(-1)}
                value="Back"
              />
            </div>
            <div>
              {loader ? (
                <div role="status">
                  <button className="btn ml-3 text-[14px]">
                    <svg
                      aria-hidden="true"
                      className="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    Sending Greetings
                  </button>
                  <span className="sr-only">Loading...</span>
                </div>
              ) : greetLoader ? (
                <div role="status">
                  <button className="btn btn--border ml-3 text-[14px]">
                    <svg
                      aria-hidden="true"
                      className="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    Skipping Greetings
                  </button>
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                <>
                  {" "}
                  <input
                    type="button"
                    className="btn btn--border object-right"
                    onClick={skipGreetingButton}
                    value="Skip to dashboard"
                  />
                  <input
                    type="submit"
                    className="btn ml-5 text-[14px]"
                    value="Send Greetings"
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </form>
      {/* #############################Template Section Starts Here#################################*/}
      {greetMsg && (
        <div className="mt-20">
          <h3 className="text-xl leading-8 font-bold text-gray-800">
            Preview of the Message:
          </h3>
          <br />
          <table
            border={0}
            cellPadding={0}
            cellSpacing={0}
            align="center"
            bgcolor="#EAF0F3"
          >
            <tbody>
              <tr>
                <td>
                  <table
                    id="Table_01"
                    width={398}
                    border={0}
                    cellPadding={0}
                    cellSpacing={0}
                    align="center"
                    style={{
                      padding: "50px 100px",
                      width: "660px",
                      margin: "0px 50px 50px 0px",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td>
                          <img
                            src="/images/ivshr_logo.svg"
                            alt=""
                            className="m-auto"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "20px",
                            textAlign: "center",
                            fontSize: "20px",
                            msoHeightRule: "exactly",
                            lineHeight: "24px",
                            color: "#000000",
                            fontFamily: "sans-serif",
                          }}
                        >
                          <span>
                            Hi{" "}
                            <span style={{ fontWeight: "bold" }}> Team </span>
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "25px 25px 15px 25px",
                            textAlign: "center",
                            fontSize: "16px",
                            msoHeightRule: "exactly",
                            lineHeight: "24px",
                            color: "#5E5E5E",
                            backgroundColor: "#ffffff",
                            fontFamily: "sans-serif",
                          }}
                        >
                          <span>Message : {greetMsg}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {/* #############################Template Section Ends Here#############################*/}
    </>
  );
};

export default GreetTeam;
